// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// local
// views
import CustomDropdown from 'app/ui/commons/CustomDropdown';
// api
import Supplier from 'app/api/supplier';
// lib
import { sortString } from 'app/lib/helper';

class DropdownSupplier extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            allOptions: [],
            options: [],
        };
    }

    filterByClientID(supplier) {
        const { clientId } = this.props;
        return clientId ? supplier.clientId === clientId : true;
    }

    componentDidMount() {
        Supplier.list()
            .then(this.onLoadClientSuccess)
            .catch(this.onLoadClientFail);
        this._isMounted = true;
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.clientId !== this.props.clientId) {
            this.onLoadClientSuccess(prevState.allOptions);
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onLoadClientSuccess = result => {
        if (this._isMounted) {
            let suppliers = result.filter(s => this.filterByClientID(s)).map(supplier => ({
                text: supplier.name,
                value: supplier.id,
            }));
            suppliers.sort((a, b) => sortString(a.text, b.text));
            const options = [{ text: '-', value: null }].concat(suppliers);
            this.setState({
                loading: false,
                allOptions: result,
                options,
            });
        }
    };

    onLoadClientFail = () => {
        if (this._isMounted) {
            this.setState({
                loading: false,
                options: [],
            });
        }
    };

    render() {
        const { options, loading } = this.state;
        let { value, onChange, label, placeholder, width, disabled, error } = this.props;
        placeholder = placeholder !== null ? placeholder : null;
        label = label !== null ? label : null;
        width = width !== null ? width : null;
        return (
            <CustomDropdown
                selection
                disabled={disabled}
                placeholder={placeholder}
                label={label}
                width={width}
                loading={loading}
                options={options}
                value={value}
                onChange={onChange}
                error={error}
            />
        );
    }
}

DropdownSupplier.propTypes = {
    disabled: PropTypes.bool,
    value: PropTypes.number,
    label: PropTypes.object,
    placeholder: PropTypes.string,
    width: PropTypes.number,
    onChange: PropTypes.func,
    clientId: PropTypes.number,
    error: PropTypes.bool,
};

export default DropdownSupplier;
